// extracted by mini-css-extract-plugin
export default {"tablehead":"FactoryTableData_tablehead__d9-mI","custom-striped-table":"FactoryTableData_custom-striped-table__FbnzZ"};